import {jsx as $hgUW1$jsx} from "react/jsx-runtime";
import {useState as $hgUW1$useState, useRef as $hgUW1$useRef, useEffect as $hgUW1$useEffect} from "react";
import {Canvas as $hgUW1$Canvas} from "glsl-canvas-js";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $7d51d0c682520757$exports = {};

$parcel$export($7d51d0c682520757$exports, "GLSL", () => $7d51d0c682520757$export$45be61eeaf561b2a);



const $7d51d0c682520757$export$45be61eeaf561b2a = ({ getInstance: getInstance, fallback: fallback, ...options })=>{
    const [error, setError] = (0, $hgUW1$useState)();
    const canvasRef = (0, $hgUW1$useRef)();
    (0, $hgUW1$useEffect)(()=>{
        if (!canvasRef?.current) return;
        const glsl = new (0, $hgUW1$Canvas)(canvasRef.current, {
            ...options,
            onError: (error)=>{
                setError(error);
                options.onError?.(error);
            }
        });
        getInstance?.(glsl);
        return ()=>{
            glsl.destroy();
        };
    }, []);
    if (error && fallback) return fallback(error);
    return /*#__PURE__*/ (0, $hgUW1$jsx)("canvas", {
        ref: canvasRef,
        style: {
            width: "100%",
            height: "100%"
        }
    });
};




export {$7d51d0c682520757$export$45be61eeaf561b2a as GLSL};
//# sourceMappingURL=module.js.map
